/**
 * The fields a pending nurse must still provide on /verifyNurse, as the labels
 * the page lists them under, in the page's order.
 *
 * Proof of license and insurance come from keyon's `has_license_file` and
 * `has_insurance_file` flags (a stored, active file is referenced), never from a
 * file path the page holds.
 *
 * @param {object} form the page's form fields
 * @param {{hasLicenseFile: boolean, hasInsuranceFile: boolean}} flags
 * @returns {string[]} empty when nothing is missing
 */
export function missingVerifyNurseFields(form, { hasLicenseFile, hasInsuranceFile } = {}) {
  const f = form || {};
  const blank = (v) => v === '' || v === null || v === undefined;
  const missing = [];
  if (blank(f.addr)) missing.push('Address');
  if (blank(f.city)) missing.push('City');
  if (blank(f.state)) missing.push('State');
  if (blank(f.zip)) missing.push('Zip');
  if (blank(f.license)) missing.push('License Number');
  if (!hasLicenseFile) missing.push('Proof of License Needed.');
  if (blank(f.licenseSt)) missing.push('License State');
  if (!hasInsuranceFile) missing.push('Proof of Insurance Needed.');
  if (blank(f.dob)) missing.push('DOB');
  if (blank(f.ssn)) missing.push("Social can't be Empty");
  const ssn = String(f.ssn == null ? '' : f.ssn).trim();
  if (ssn.length > 0 && ssn.length !== 4) missing.push('Social Must Be at Least 4 Numbers');
  return missing;
}
